// Certificate actions
export const SET_CERTIFICATE_CODE = 'SET_CERTIFICATE_CODE';
export const SET_IS_CERTIFICATE_VALIDATING = 'SET_IS_CERTIFICATE_VALIDATING';
export const GET_CERTIFICATE_CODE_VALIDATION_RESULT = 'GET_CERTIFICATE_CODE_VALIDATION_RESULT';
export const SET_HAS_VALIDATION_ERROR = 'SET_HAS_VALIDATION_ERROR';
export const SET_IS_DROPPED_CUSTOM_VALIDATION = 'SET_IS_DROPPED_CUSTOM_VALIDATION';
// Redemption actions
export const SET_REDEMPTION_CODE = 'SET_REDEMPTION_CODE';
export const GET_REDEMPTION_CODE_VALIDATION_RESULT = 'GET_REDEMPTION_CODE_VALIDATION_RESULT';
export const SET_HAS_REDEMPTION_ERROR = 'SET_HAS_REDEMPTION_ERROR';
export const SET_IS_REDEMPTION_VALIDATING = 'SET_IS_REDEMPTION_VALIDATING';
export const RESET_REDEMPTION_STATE = 'RESET_REDEMPTION_STATE';
